<template>
  <div class="user_info" v-if="init">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { goToLoginPage, isLogin } from '@/utils';

export default {
  data() {
    return {
      init: false,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  watch: {
    $route(to, from) {
      if (to.name === 'UserInfo') {
        this.checkRedirect();
      }
    },
  },
  async created() {
    if (!isLogin()) {
      goToLoginPage();
    }
    const apiReturn = await this.getUserInfo();
    if (apiReturn === 0) {
      this.init = true;
      this.checkRedirect();
    } else if (apiReturn === 3016) {
      // 팝업 띄우기. 다국어 처리도 필요함.
      this.openModal({
        type: 'alert',
        message: this.$t('userInfo.needVerifiedId'),
        callback: () => {
          history.back();
        },
      });
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['getUserInfo', 'setModifyUserName']),
    checkRedirect() {
      const { isFirst, isBusinessFirst } = this.userInfo;

      // [개인정보 등록이 없는 경우]
      if (isFirst) {
        // 사업자 정보 등록 여부와 상관 없이 등록화면으로 이동하도록 변경됨
        return this.$router.replace({ name: 'UserInfoRegister' }).catch(() => {});
      }

      // [개인정보 등록이 있는 경우]
      // 유형과 무관하게 유저 정보 페이지로 이동
      return this.$router.replace({ name: 'UserInfoView' }).catch(() => {});
    },
  },
  mounted() {
    this.setModifyUserName({});
  },
};
</script>

<style></style>
